import React from 'react'
import {DropdownTheme, Dropdown as TPADropdown} from 'wix-ui-tpa/cssVars'
import type {DropdownProps as TPADropdownProps} from 'wix-ui-tpa/cssVars'

import {st, classes} from './styles.st.css'

export const Dropdown = ({className, theme, ...rest}: TPADropdownProps) => {
  const dropdownThemeClass = theme === DropdownTheme.Box ? classes.box : classes.line
  return (
    <TPADropdown
      className={st(className, classes.dropdown, dropdownThemeClass)}
      theme={theme}
      {...rest}
    />
  )
}
